var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: { title: _vm.form.id ? "修改" : "新增", visible: _vm.dialogShow },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标题", prop: "title" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入标题" },
                model: {
                  value: _vm.form.title,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "作者", prop: "title" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入作者" },
                model: {
                  value: _vm.form.author,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "author", $$v)
                  },
                  expression: "form.author"
                }
              })
            ],
            1
          ),
          _vm.language.length
            ? _c(
                "el-form-item",
                { attrs: { label: "公告分类", prop: "type_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", clearable: "" },
                      on: { change: _vm.announceTypeChange },
                      model: {
                        value: _vm.form.type_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "type_id", $$v)
                        },
                        expression: "form.type_id"
                      }
                    },
                    _vm._l(_vm.announceTypeList, function(item, index) {
                      return _c(
                        "el-option",
                        {
                          key: index,
                          attrs: { label: item.name, value: item.id }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.name +
                                  "(" +
                                  _vm.language.filter(function(i) {
                                    return i.value == item.language
                                  })[0].label +
                                  ")"
                              ) +
                              " "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "公告类型", prop: "game_type" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择公告类型" },
                  model: {
                    value: _vm.form.game_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "game_type", $$v)
                    },
                    expression: "form.game_type"
                  }
                },
                _vm._l(_vm.AnnouncemenTypeList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否置顶", prop: "top" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.top,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "top", $$v)
                    },
                    expression: "form.top"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "是", value: 1 } }),
                  _c("el-option", { attrs: { label: "否", value: 0 } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否为轮播图", prop: "is_banner" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.is_banner,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "is_banner", $$v)
                    },
                    expression: "form.is_banner"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "是", value: 1 } }),
                  _c("el-option", { attrs: { label: "否", value: 0 } })
                ],
                1
              )
            ],
            1
          ),
          _vm.form.is_banner
            ? _c(
                "el-form-item",
                { attrs: { label: "轮播图标题", prop: "banner_title" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入轮播图标题" },
                    model: {
                      value: _vm.form.banner_title,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "banner_title", $$v)
                      },
                      expression: "form.banner_title"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.is_banner,
                  expression: "form.is_banner"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                label: "轮播图",
                prop: "cover",
                rules: _vm.form.is_banner
                  ? _vm.rules.cover
                  : [{ require: false }]
              }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.picfileList },
                on: { input: _vm.imgChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "state" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.state,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state", $$v)
                    },
                    expression: "form.state"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "is_timing", label: "定时发送" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "operationFrame-entity",
                  attrs: { placeholder: "请选择是否定时发送" },
                  on: { change: _vm.isTimeChange },
                  model: {
                    value: _vm.form.is_timing,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "is_timing", $$v)
                    },
                    expression: "form.is_timing"
                  }
                },
                _vm._l(_vm.timingList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.form.is_timing == 1
            ? _c(
                "el-form-item",
                { attrs: { prop: "timing", label: "发送时间" } },
                [
                  _c("el-date-picker", {
                    staticClass: "operationFrame-entity",
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      "value-format": "timestamp",
                      type: "datetime",
                      placeholder: "日期"
                    },
                    model: {
                      value: _vm.form.timing,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "timing", $$v)
                      },
                      expression: "form.timing"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "是否开放评论", prop: "comment_type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.comment_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "comment_type", $$v)
                    },
                    expression: "form.comment_type"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("开放")
                  ]),
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("不开放")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "内容", prop: "content" }
            },
            [
              _c("Editor", {
                on: { onEditorChange: _vm.onEditorChange },
                model: {
                  value: _vm.form.content,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(_vm.form.id)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }